import { Gamecloud } from "../../../gamecloud";
import { createGameserverStatusUI, GameserverStatusUI } from './gameserverStatusUI';
import { Notification } from "../../../../notification/notfication";
import Axios from "axios";
import { Dialog } from "../../../../dialog/dialog";
import i18next from "i18next";

export class GameserverStatus extends Gamecloud {
  
  public constructor(private ui: GameserverStatusUI) {
    super();
    
    window.addEventListener('socketData', (event: CustomEvent) => {
      this.ui.renderCPU(event.detail.data);
      this.ui.renderRAM(event.detail.data);
    });
    
    this.ui.onReinstallClick(this.reinstall.bind(this))
  }
  
  public reinstall(url: string) {
    this.ui.disableReinstallButton(true);

    new Dialog()
    .withTitle(i18next.t('general:non_special_texts.are_you_sure'))
    .withText(i18next.t('gameserver:reinstall.question'))
    .withConfirmButtonText(i18next.t('general:non_special_texts.confirm'))
    .withCenteredContent()
    .withOnConfirm(() => {
      this.loader.enable();
      Axios.post(url, {}, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then((response) => response.status === 200 && response.data.result === null)
      .then((state: boolean) => {
        if (state) {
          new Notification(
            'success',
            i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_success.title'),
            i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_success.text')
          );
        }
        else {
          new Notification(
            'danger',
            i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_error.title'),
            i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_error.text')
          );
        }

        this.ui.disableReinstallButton(false);
        this.loader.disable();
      }, () => {
        new Notification(
          'danger',
          i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_error.title'),
          i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_error.text')
        );
      });
    })
    .withOnCancel(() => this.ui.disableReinstallButton(false))
    .withIcon()
    .render();


  }
}

export function initGameserverStatus() {
  const uiInstances: GameserverStatusUI[] = createGameserverStatusUI();
  return uiInstances.map((ui: GameserverStatusUI) => {
    return new GameserverStatus(ui);
  });
}
